import { createFileRoute } from "@tanstack/react-router";

import { NewThreadContainer } from "@/features/app-support/containers/new-thread-container";

export const Route = createFileRoute("/app/settings/user/support/new")({
  component: NewThreadContainer,
});
